import { QueryClientProvider } from "@tanstack/react-query";
import type React from "react";

import { useCreateQueryClient } from "~/hooks/query";

import { PackGrid } from "./PackGrid";

export const ConnectedPackGrid: React.FC<
  React.ComponentProps<typeof PackGrid>
> = (props) => {
  const queryClient = useCreateQueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <PackGrid {...props} />
    </QueryClientProvider>
  );
};
